import {
  useProductPeriodicityMap,
  usePatchCustomerPeriodicities,
  PeriodicityTypes,
} from '@hungryroot/components-osn';

import { useIdentify } from '@hungryroot/rest-hooks';
import {
  type RatableProductItem,
  type RatablePairingItem,
} from '../useRatableItems';

export type UseFoodFeedbackNeverProps = {
  item: RatablePairingItem | RatableProductItem;
  rating: boolean | null;
};

export const useFoodFeedbackNever = (props: UseFoodFeedbackNeverProps) => {
  const { item, rating } = props;
  const {
    data: productPeriodicityMapData,
    isLoading: productPeriodicityMapIsLoading,
  } = useProductPeriodicityMap();

  const { customerData } = useIdentify();

  // We only show the never toggle if this is a product
  const productId = 'productId' in item ? item.productId : null;
  const periodicity = productId
    ? productPeriodicityMapData?.get(productId)
    : null;

  const patchCustomerPeriodicities = usePatchCustomerPeriodicities();

  const onToggleNever = () => {
    if (!customerData || !productId) {
      return;
    }

    const newPeriodicity =
      periodicity === PeriodicityTypes.NEVER
        ? PeriodicityTypes.UNSET
        : PeriodicityTypes.NEVER;

    patchCustomerPeriodicities.mutate({
      customerId: customerData.id,
      data: {
        periodicity: newPeriodicity,
        product: productId,
      },
    });
  };

  const renderNeverToggle = Boolean(
    !productPeriodicityMapIsLoading &&
      productId &&
      customerData &&
      rating === false
  );

  return {
    renderNeverToggle,
    onToggleNever,
    isToggleSelected: periodicity === PeriodicityTypes.NEVER,
  };
};
